module.exports = __webpack_public_path__ + "img/camera_default.a69d2669.svg";